// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner{width:100%;min-height:570px}.banner .swiper-wrapper{width:100%;height:100%}.banner .swiper-wrapper .swiper-slide{width:100%}.banner .swiper-wrapper .swiper-slide img{width:100%;height:100%}.banner .swiper-pagination{bottom:90px}.banner .swiper-pagination .swiper-pagination-bullet{width:43px;height:4px;border-radius:2px;background:#fff}.banner .swiper-pagination .swiper-pagination-bullet-active{background:#fff!important}", ""]);
// Exports
module.exports = exports;
